jQuery(document).ready(function($) {
	$('.home-slider .slick').slick({
		dots: true,
		nav: false,
		arrows: true,
		adaptiveHeight: false,
		infinite: true,
		fade: true,
		prevArrow: '<span class="slick-prev hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-left"></span></span>',
		nextArrow: '<span class="slick-next hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-right"></span></span>',
	});
	$('.home-slider .slick .slick-dots > li').each(function(){
		$(this).find('button').text( 0 + $(this).find('button').text() );
	});

	$('.item-new-products .slick').slick({
		dots: true,
		nav: false,
		arrows: true,
		adaptiveHeight: false,
		infinite: true,
		fade: true,
		prevArrow: '<span class="slick-prev hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-left"></span></span>',
		nextArrow: '<span class="slick-next hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-right"></span></span>',
	});
	$('.item-new-products .slick .slick-dots > li').each(function(){
		$(this).find('button').text( 0 + $(this).find('button').text() );
	});

	if( isBreakpoint('xs') ){
		var isotope_container = $('.home-boxes #boxes_grid');
		isotope_container.imagesLoaded(function(){
			isotope_container.isotope({
				itemSelector: '.grid-item',
				percentPosition: true,
				masonry: {
					columnWidth: '.grid-sizer'
				}
			})
		});
	}
	if( isBreakpoint('lg') ){
		var oldSrc = '';
		$('.home-boxes .item.item-categories>div>div>a').hover(function(){
			var image = $(this).find('img:not(.hidden)');

			oldSrc = image.attr('src');

			image.attr('src', image.data('hover'));
		},function(){
			$(this).find('img:not(.hidden)').attr('src', oldSrc);
		});
	}

	$('#modalRegistrati .custom-select').SumoSelect();
});
